
import { supabase } from '@/integrations/supabase/client';

export interface UserConnection {
  id: string;
  user_id: string;
  connected_user_id: string;
  connection_type: 'follow' | 'connect' | 'block';
  user_type: 'supabase' | 'internal';
  connected_user_type: 'supabase' | 'internal';
  status: 'pending' | 'accepted' | 'rejected';
  created_at: string;
  updated_at: string;
}

export const userConnectionsService = {
  async createConnection(
    userId: string,
    connectedUserId: string,
    connectionType: 'follow' | 'connect',
    userType: 'supabase' | 'internal',
    connectedUserType: 'supabase' | 'internal'
  ) {
    console.log('Creating connection:', { userId, connectedUserId, connectionType, userType, connectedUserType });
    
    // Check if connection already exists
    const existingConnection = await this.getConnectionStatus(userId, connectedUserId);
    const existingOfType = existingConnection.find(conn => conn.connection_type === connectionType);
    
    if (existingOfType) {
      console.log('Connection already exists:', existingOfType);
      return existingOfType;
    }
    
    const { data, error } = await supabase
      .from('user_connections')
      .insert({
        user_id: userId,
        connected_user_id: connectedUserId,
        connection_type: connectionType,
        user_type: userType,
        connected_user_type: connectedUserType,
        status: connectionType === 'follow' ? 'accepted' : 'pending'
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating connection:', error);
      throw error;
    }
    
    console.log('Connection created successfully:', data);
    return data;
  },

  async getConnections(userId: string, connectionType?: string) {
    let query = supabase
      .from('user_connections')
      .select('*')
      .eq('user_id', userId);

    if (connectionType) {
      query = query.eq('connection_type', connectionType);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data;
  },

  async getConnectionStatus(userId: string, connectedUserId: string) {
    const { data, error } = await supabase
      .from('user_connections')
      .select('*')
      .eq('user_id', userId)
      .eq('connected_user_id', connectedUserId);

    if (error) throw error;
    return data;
  },

  async updateConnectionStatus(
    userId: string,
    connectedUserId: string,
    connectionType: string,
    status: 'accepted' | 'rejected'
  ) {
    const { data, error } = await supabase
      .from('user_connections')
      .update({ status, updated_at: new Date().toISOString() })
      .eq('user_id', userId)
      .eq('connected_user_id', connectedUserId)
      .eq('connection_type', connectionType)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async removeConnection(userId: string, connectedUserId: string, connectionType: string) {
    const { error } = await supabase
      .from('user_connections')
      .delete()
      .eq('user_id', userId)
      .eq('connected_user_id', connectedUserId)
      .eq('connection_type', connectionType);

    if (error) throw error;
  }
};
